
<div class="toggle-token-container">
  <label class="switch" :for="checkboxId">
    <input :id="checkboxId" :value="toggleState" type="checkbox" :checked="toggleState" class="hidden" @input="updateInput" />
    <div
      class="toggle-token"
      :class="hasError && 'error'"
      tabindex="0"
      role="checkbox"
      :aria-checked="toggleState"
      :aria-label="ariaLabel"
      @keydown.space.prevent="updateInput"
    >
      <component :is="icon" :class="iconClasses" :width="iconWidth" :height="iconHeight" :active="false" hasSimpleLabel />
      <slot name="formattedText" />
      {{ text }}
    </div>
  </label>
</div>
